import React from 'react';
import { FaCalendarAlt, FaMapMarkerAlt, FaClock } from 'react-icons/fa';

const UpcomingEvents = () => {
  const events = [
    {
      id: 1,
      title: "Blood Donation Camp",
      description: "Join us for our monthly blood donation camp. Your contribution can save lives.",
      date: "2025-04-15",
      time: "10:00 AM - 4:00 PM",
      location: "Community Health Center, Hisar",
      image: "https://images.unsplash.com/photo-1615461066841-6116e61058f4?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
    },
    {
      id: 2,
      title: "Health Awareness Workshop",
      description: "Learn about preventive healthcare and wellness practices from medical experts.",
      date: "2025-04-20",
      time: "2:00 PM - 5:00 PM",
      location: "VALARCCI Foundation Office, Hisar",
      image: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
    },
    {
      id: 3,
      title: "Medical Camp for Rural Areas",
      description: "Free medical checkup and medicine distribution for underprivileged communities.",
      date: "2025-04-25",
      time: "9:00 AM - 2:00 PM",
      location: "Rural Health Center, Bandaheri",
      image: "https://images.unsplash.com/photo-1584982751601-97dcc096659c?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
    },
    {
      id: 4,
      title: "First Aid Training Program",
      description: "Essential first aid training for community members and volunteers.",
      date: "2025-05-01",
      time: "11:00 AM - 3:00 PM",
      location: "VALARCCI Training Center, Hisar",
      image: "https://images.unsplash.com/photo-1579684385127-1ef15d508118?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
    }
  ];

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };

  return (
    <div className="min-h-screen py-12 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-[#6dd5ed] to-[#eecda3]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-black mb-4">Upcoming Events</h1>
          <p className="text-xl text-black">Join us in our mission to serve the community</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8">
          {events.map((event) => (
            <div key={event.id} className="bg-white rounded-lg overflow-hidden shadow-xl transform transition-all duration-300 hover:scale-[1.02]">
              <div className="relative h-48">
                <img
                  src={event.image}
                  alt={event.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute bottom-4 left-4 text-white">
                  <h3 className="text-xl font-bold">{event.title}</h3>
                </div>
              </div>
              <div className="p-6">
                <div className="flex items-center space-x-2 text-gray-600 mb-4">
                  <FaCalendarAlt className="text-blue-500" />
                  <span>{formatDate(event.date)}</span>
                </div>
                <div className="flex items-center space-x-2 text-gray-600 mb-4">
                  <FaClock className="text-blue-500" />
                  <span>{event.time}</span>
                </div>
                <div className="flex items-center space-x-2 text-gray-600 mb-4">
                  <FaMapMarkerAlt className="text-blue-500" />
                  <span>{event.location}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default UpcomingEvents; 